import React, { useRef, useEffect, useState } from 'react';
import './e_sign.css'
import {Modal, Button, Table} from 'react-bootstrap';
import { BiRevision, BiRefresh, BiPencil } from "react-icons/bi";
import SelectMarkOnPdf from './E_sign/selectmarkonPdf';
const ESignIn=()=>{
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedIndex, setselectedindex]=useState(null)
  const [data, setdata]=useState([
    {
      title:'offer letter',
      creatded_by:'1593.amit@gmail.com',
      created_for:'al@gmai.com',
      sendeedmail:'1593.amit@gmail.com',
      sendeedmobile:'9999999999',
      validtill:'03-Nov-2021',
      txnid:'1232211',
      type:'Normal',
      status:'sign',
      checked:false
    }
  ])
  return (
    <div>
      <div>
        <button onClick={handleShow}>Creat A transation</button>
        <div>
          {selectedIndex!==null&&
            <div style={{width:450, paddingTop:15}}>
               {data[selectedIndex].checked&&
                <ul style={{listStyle:'none', display:'flex', justifyContent:'space-around'}}>
                  <li style={{cursor:'pointer'}}><BiRevision/>{" "}Refresh</li>
                  <li style={{cursor:'pointer'}}><BiRefresh/>{" "}Re-assign</li>
                  <li style={{cursor:'pointer'}}><BiRefresh/>{" "}Re-assign all</li>
                  <li style={{cursor:'pointer'}}><BiPencil/>{" "}Esign</li>
                </ul>
              }
              </div>
            }
            <Table striped style={{
              width:'100%',
              display:'block',
              background:'#FFF',
            }} hover>
              <thead>
                <tr>
                  <th></th>
                  <th>Title</th>
                  <th>Created By</th>
                  <th>Created For</th>
                  <th>Sendees email</th>
                  <th>Sendeed Mobile</th>
                  <th>Valid Till</th>
                  <th>Txn Id</th>
                  <th>Type</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data.map((value, i)=>(
                  <tr key={i}>
                    <td><input onChange={(ev)=>{
                      let ndata=[...data]
                      ndata[i].checked=!value.checked
                      setdata(ndata)
                      setselectedindex(i)
                      console.log(ev.target.value)
                    }} type="checkbox" checked={value.checked}/></td>
                    <td>{value.title}</td>
                    <td>{value.creatded_by}</td>
                    <td>{value.created_for}</td>
                    <td>{value.sendeedmail}</td>
                    <td>{value.sendeedmobile}</td>
                    <td>{value.validtill}</td>
                    <td>{value.txnid}</td>
                    <td>{value.type}</td>
                    <td>{value.status}</td>
                  </tr>
                )
                )}
              </tbody>
            </Table> 
        </div>

      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header >
          <Modal.Title>Creat A Transation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
            <div>
              <div>
                <span>eSign REQUEST DETAILS</span>
              </div>
              <div>
                <input type='text' placeholder='Title*'/>
              </div>
              <div>
                <input type='text' value='30' placeholder='Validity (Days)*'/>
              </div>
              <div>
                <label>TEMPLETE</label>
                <div>
                  <select className='form-control'>
                    <option key='-1' value="">Select Signature Templete</option>
                    <option>b</option>
                    <option>c</option>
                    <option>d</option>
                  </select>
                </div>
              </div>
            </div>
            <div style={{width:15}}></div>
            <div>
              <textarea placeholder='Message*' style={{height:100}}></textarea>
              <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                <div>
                  <span>
                    <div>
                      <input type='checkbox'/>
                    </div>
                    I m authorize Signature
                  </span>
                </div>
                <div>
                  <select style={{width:100}} className='form-control'>
                    <option key='-1' value="">Select auth type</option>
                    <option>Email Otp</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
              <div>
                  <div>
                    <label>
                      <input type='checkbox' checked/> First Party
                    </label>
                    
                  </div>
                  <div> 
                      <select className='form-control'>
                        <option key='-1' value="">Select Name</option>
                        <option>b</option>
                        <option>c</option>
                        <option>d</option>
                      </select>
                  </div>
                  <div>
                    <input type='text' placeholder='Email id'/>
                  </div>
                  <div>
                    <input type='text' placeholder='Mobile Number'/>
                  </div>
                  <div>
                    <input type='text' placeholder='Organisation'/>
                  </div>
              </div>
              <div style={{width:15}}></div>
              <div>
                  <div>
                    <label>
                      <input type='checkbox' checked/> Second Party
                    </label>
                    
                  </div>
                  <div> 
                      <select className='form-control'>
                        <option key='-1' value="">Select Name</option>
                        <option>b</option>
                        <option>c</option>
                        <option>d</option>
                      </select>
                  </div>
                  <div>
                    <input type='text' placeholder='Email id'/>
                  </div>
                  <div>
                    <input type='text' placeholder='Mobile Number'/>
                  </div>
                  <div>
                    <input type='text' placeholder='Organisation'/>
                  </div>
              </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save 
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
      <SelectMarkOnPdf/>
    </div>
  );
};

export default ESignIn;